var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClub = function SvgIconClub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.354 8.396a5.5 5.5 0 1 1-1.812 10.814l.44 2.356A1 1 0 0 1 15 22.75H9a1 1 0 0 1-.983-1.184l.441-2.356a5.5 5.5 0 0 1-5.206-1.427 5.5 5.5 0 0 1 3.394-9.387A5.4 5.4 0 0 1 6.5 7.123a5.5 5.5 0 0 1 11 0 5.4 5.4 0 0 1-.146 1.273M12 3.625a3.5 3.5 0 0 0-3.5 3.5v.005c-.003.649.178 1.286.523 1.837a1 1 0 0 1-1.072 1.505 3.8 3.8 0 0 0-.829-.097 3.5 3.5 0 1 0 2.08 6.315 1 1 0 0 1 1.578.988l-.575 3.072h3.59l-.575-3.072a1 1 0 0 1 1.577-.988 3.5 3.5 0 1 0 1.252-6.219 1 1 0 0 1-1.072-1.504c.345-.551.526-1.188.523-1.837v-.005a3.5 3.5 0 0 0-3.5-3.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconClub;